import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Helmet } from 'react-helmet';
import Casestudyback from '../../../../Component/Casestudyback'
import Banner from "../../../../asset/images/insight/case_studies/banner-automated-website-change-tracking.webp"
import { Link } from 'react-router-dom';

export default function AutomatedWebsiteChange() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Helmet><meta charset="UTF-8" />
                <meta charset="UTF-8" />
                <title>Scalable Website Change Tracking for Financial Analytics | DPA</title>
                <meta name="description" content="Learn how Decimal Point Analytics automated website change tracking for financial firm, saving time and providing real-time insights for better decision-making." />
                <link rel="canonical" href="https://decimalpointanalytics.com/case-study/scalable-website-change-tracking-financial-analytics" />
            </Helmet>

            <Box id="case-studies" className='section sec_bg new_cs' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={3} alignItems="top" justifyContent='center'>
                        <Grid item lg={7} md={7} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h3' className='subhead skblue al_center'>
                                    Success Stories
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Automated Website Change Tracking <span className='lower'>for</span> Financial Analytics | Scalable Solutions
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box>
                        <img loading="lazy" src={Banner} className='w100' alt='Banner' />
                    </Box>

                    <Box className='whitebx'>

                        <Box>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Client Overview
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                The client is a leading financial research firm that tracks frequent website changes for competitive intelligence. They monitor 302 websites and 45,000+ webpages, requiring accurate and timely updates to support strategic decisions.
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Problem Statement
                            </Typography>

                            <Typography variant='h3' className='black jst h3h6' gutterBottom>
                                Challenges of Manual Website Tracking for Financial Firms
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Manual Tracking:</strong> Inefficient manual tracking of 302 websites and 45,000+ webpages, leading to delays and data inconsistencies.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Lack of Centralization:</strong> No centralized system to capture, store, and compare website changes.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Operational Challenges:</strong> High operational costs and resource-intensive processes with limited scalability.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Decision-Making Impact:</strong> Lack of real-time insights hampering strategic decision-making and market responsiveness.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Solution Provided
                            </Typography>

                            <Typography variant='h3' className='black jst h3h6' gutterBottom>
                                How Automation Transformed Website Change Monitoring
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Automation:</strong> Deployed <Link to="/data-solution-in-us" className='link'>automated web scraping</Link> to systematically extract and track text and numeric changes from multiple websites.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>AI-Powered Portal:</strong> Developed an AI-powered comparison portal to store, analyze, and visualize periodic website changes.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Data Extraction:</strong> Implemented interval-based data extraction every 15 days to ensure accurate and timely updates.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Integration:</strong> Integrated multiple output formats (HTML, snapshots, databases) for seamless access and analysis.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>


                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Outcome
                            </Typography>

                            <Typography variant='h3' className='black jst h3h6' gutterBottom>
                                Real-Time Insights and Cost Savings for Financial Decision-Making
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Cost and Time Savings:</strong> Significant cost and time savings through process automation, reducing manual efforts.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Enhanced Insights:</strong> Real-time insights and improved accuracy with structured data extraction and visualization.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Efficiency Boost:</strong> Enhanced efficiency in monitoring competitors, regulatory updates, and market changes.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>Scalability:</strong> Scalable and customizable platform adaptable to future expansion and diverse business needs.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>

                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Key Takeaways
                            </Typography>

                            <Typography variant='h3' className='black jst h3h6' gutterBottom>
                                Accuracy, Efficiency, and Scalability
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Automation ensured accurate website change tracking across 300+ sources.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Reduced manual efforts and time spent on website monitoring.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Provided real-time, actionable insights to enhance strategic decision-making.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            A scalable solution for future-proofing business needs.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                Looking to automate your data tracking and gain real-time insights for better decision-making? <Link to="/contact-us#contact_form" className='link'>Contact</Link> <strong>Decimal Point Analytics</strong> today for a tailored solution to streamline your operations and drive efficiency.
                            </Typography>

                        </Box>
                    </Box>

                    <Casestudyback />

                </Container>
            </Box>
        </>
    );
}